// Virtual Project Account types. Values must match the backend
// api.models.project_account.ProjectAccountType choices.
export const PROJECT_ACCOUNT_TYPES = ['funds', 'revenue', 'expenses', 'investment'];

// i18n key for a given project account type value.
export function projectAccountTypeLabelKey(value) {
    return `app.projectAccounts.types.${value}`;
}
